export default "__VITE_PUBLIC_ASSET__905dd45a__"